
import { Database } from './database';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { NL_Servis } from '../models/NL_Servis';



@Injectable()
export class BllServisBilgisi extends Database {

  constructor() {
    super("NL_Servis");

  }

  servisBilgisiGuncelle(guncellenecekElement:NL_Servis){
    return new Promise((res,err)=>{
      this.execRawQueryWithParams("update NL_Servis set ADRES = ? where ID = ?",[guncellenecekElement.ADRES,guncellenecekElement.ID]).then(a=>{
        res(a);
      }).catch(x=>{
        err(x);
      })
    })
  }



}



// WEBPACK FOOTER //
// ./src/providers/bll-servis-bilgisi.ts